'use strict';

import 'chosen';

export default function chosen() {
    $('.js-chosen-select').chosen({
        /* jshint camelcase:false */
        disable_search: true,
        /* jshint camelcase:false */
        width: '100%',
    });
}
